var exports = {
  "kL": "xaee3c4fa--9ae89a--container",
  "Hs": "xaee3c4fa--9ae89a--photo-block",
  "Qs": "xaee3c4fa--9ae89a--content",
  "cn": "xaee3c4fa--9ae89a--photo-label",
  "w7": "xaee3c4fa--9ae89a--annotation",
  "tX": "xaee3c4fa--9ae89a--title-container",
  "K2": "xaee3c4fa--9ae89a--logo-container",
  "Ht": "xaee3c4fa--9ae89a--mortgage-disclaimer",
  "VD": "xaee3c4fa--9ae89a--container--mortgage-annotations",
};

module.exports = exports;
